import createVueComponent from '../createVueComponent';
var Navigation = createVueComponent('NavigationIcon', [['polygon', {
  points: '3 11 22 2 13 21 11 13 3 11',
  key: '1ltx0t'
}]]);
export default Navigation;